import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const DEMO_COMPONENT_ROUTES = [
    {'path': 'components/alert', 'loadChildren': () => import('./ui/alert/index.module').then(m => m.NzDemoAlertModule)},
    {'path': 'components/auto-complete', 'loadChildren': () => import('./ui/auto-complete/index.module').then(m => m.NzDemoAutoCompleteModule)},
    {'path': 'components/avatar', 'loadChildren': () => import('./ui/avatar/index.module').then(m => m.NzDemoAvatarModule)},
    {'path': 'components/badge', 'loadChildren': () => import('./ui/badge/index.module').then(m => m.NzDemoBadgeModule)},
    {'path': 'components/breadcrumb', 'loadChildren': () => import('./ui/breadcrumb/index.module').then(m => m.NzDemoBreadcrumbModule)},
    {'path': 'components/button', 'loadChildren': () => import('./ui/button/index.module').then(m => m.NzDemoButtonModule)},
    {'path': 'components/calendar', 'loadChildren': () => import('./ui/calendar/index.module').then(m => m.NzDemoCalendarModule)},
    {'path': 'components/card', 'loadChildren': () => import('./ui/card/index.module').then(m => m.NzDemoCardModule)},
    {'path': 'components/carousel', 'loadChildren': () => import('./ui/carousel/index.module').then(m => m.NzDemoCarouselModule)},
    {'path': 'components/cascader', 'loadChildren': () => import('./ui/cascader/index.module').then(m => m.NzDemoCascaderModule)},
    {'path': 'components/checkbox', 'loadChildren': () => import('./ui/checkbox/index.module').then(m => m.NzDemoCheckboxModule)},
    {'path': 'components/progress', 'loadChildren': () => import('./ui/progress/index.module').then(m => m.NzDemoProgressModule)},
    {'path': 'components/rate', 'loadChildren': () => import('./ui/rate/index.module').then(m => m.NzDemoRateModule)},
    {'path': 'components/skeleton', 'loadChildren': () => import('./ui/skeleton/index.module').then(m => m.NzDemoSkeletonModule)},
    {'path': 'components/typography', 'loadChildren': () => import('./ui/typography/index.module').then(m => m.NzDemoTypographyModule)},
];

const routes: Routes = [
    ...DEMO_COMPONENT_ROUTES,
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ComponentsRoutingModule { }
